<template>
  <LazyModal :show="showModal" @update-show="showModal = $event">
    <template v-slot:header>
      <h2 class="h2 mb-3">{{ isDutch ? "Maak account" : "Create Account" }}</h2>
      <p class="mb-0">
        {{
          isDutch ? "Registreer gratis een nieuw account." : "Register a new account for free."
        }}
      </p>
    </template>
    <template v-slot:body>
      <form @submit.prevent="signIn">
        <div class="input-group position-relative mb-2">
          <div class="input-group-text">
            <i class="fa-solid fa-at"></i>
          </div>
          <input type="email" class="form-control form-control-lg" id="email"
                 :placeholder="isDutch ? 'E-mailadres' : 'Email address'" v-model="credentials.email">
        </div>
        <div class="input-group position-relative mb-2">
          <div class="input-group-text">
            <i class="fa-solid fa-lock"></i>
          </div>
          <input type="password" class="form-control form-control-lg" id="password"
                 :placeholder="isDutch ? 'Wachtwoord' : 'Password'" v-model="credentials.password">
        </div>

        <div class="input-group position-relative">
          <div class="input-group-text">
            <i class="fa-solid fa-lock"></i>
          </div>
          <input type="password" class="form-control form-control-lg" id="password_confirmation"
                 :placeholder="isDutch ? 'Herhaal wachtwoord' : 'Confirm Password'" v-model="credentials.password_confirmation">
        </div>

        <div class="input-group position-relative mt-4 mb-2">
          <input v-if="isReady"
                 type="submit"
                 :disabled="isLoading"
                 @click="signIn"
                 :value="(isDutch ? 'Registreren' : 'Register')"
                 class="btn btn-primary btn-sm fw-bold w-100 text-white">
          <input v-else
                 type="submit"
                 disabled
                 :value="(isDutch ? 'Voer alle velden in' : 'Fill in all the fields.')"
                 class="btn btn-primary btn-sm fw-bold w-100 text-white">
        </div>

        <div v-if="isError" class="alert alert-danger mb-1 mt-3" role="alert">
          <p class="mb-0 small" v-if="isDutch">
            Ongeldige gegevens. Controleer de invoer en probeer opnieuw.
          </p>
          <p class="mb-0 small" v-else>Invalid details. Please double-check your input and try again.</p>
        </div>
        <div v-if="isSuccess" class="alert alert-success mb-1 mt-3" role="alert">
          <p class="mb-0 small" v-if="isDutch">
            Gelukt! Je kunt nu inloggen met je e-mailadres en wachtwoord.
          </p>
          <p class="mb-0 small" v-else>Success! You can now log in with your email address and password.</p>
        </div>
      </form>
    </template>
  </LazyModal>
</template>

<script setup lang="ts">
import {useAuthStore} from "~/store/auth";
import JSConfetti from 'js-confetti';

const authStore = useAuthStore();
const { proxy } = useScriptGoogleAnalytics()
let jsConfetti: JSConfetti | null = null;

onMounted(() => {
  jsConfetti = new JSConfetti();
});

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  }
});

const showModal = ref(props.show);

const emit = defineEmits(['update-show']);

watch(showModal, (newVal) => {
  if (!newVal) {
    emit('update-show', newVal);
  }
});

const isDutch = inject('isDutch');

const isLoading = ref(false);

const credentials = ref({
  email: '',
  password: '',
  password_confirmation: ''
});

const isReady = computed(() => {
  return credentials.value.email &&
      credentials.value.password &&
      credentials.value.password_confirmation &&
      credentials.value.password === credentials.value.password_confirmation;
})

const isError = ref(false);

const isSuccess = ref(false);

async function signIn() {
  isLoading.value = true;
  try {
    await authStore.register(
        {
          email: credentials.value.email,
          password: credentials.value.password
        }
    )
    await proxy.gtag("event", "sign_up");
    await jsConfetti.addConfetti({
      emojis: ['✈️', '🌎️', '🗺️', '✨', '🎫'],
    })
    isSuccess.value = true;
  } catch (e) {
    isError.value = true
    isLoading.value = false;
  }
}

watch(() => props.show, (newVal) => {
  showModal.value = newVal;
});

</script>